var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplaint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e3e3e3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280-316.92q15.08 0 25.23-10.16 10.15-10.15 10.15-25.23 0-15.07-10.15-25.23-10.15-10.15-25.23-10.15t-25.23 10.15q-10.15 10.16-10.15 25.23 0 15.08 10.15 25.23 10.15 10.16 25.23 10.16Zm-30-118.46h60v-207.7h-60v207.7ZM410-370h300v-60H410v60Zm0-160h300v-60H410v60ZM172.31-180Q142-180 121-201q-21-21-21-51.31v-455.38Q100-738 121-759q21-21 51.31-21h615.38Q818-780 839-759q21 21 21 51.31v455.38Q860-222 839-201q-21 21-51.31 21H172.31Zm0-60h615.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-455.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H172.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v455.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85ZM160-240v-480 480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaint);
export default __webpack_public_path__ + "static/media/complaint.6ce59e6b72bece1c08e04f19dbdabb68.svg";
export { ForwardRef as ReactComponent };